export const siteName = '韩国漫画';

export const headerNavItems = [
  { label: '首页', href: '#hero' },
  { label: '精彩视频', href: '#media' },
  { label: '联系我们', href: '#contact' },
  { label: '专题合集', href: '#index' },
  { label: '关于我们', href: '#about' },
  { label: '更新动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
];

export const heroData = {
  tag: '🔥 每日更新 · 高清画质 · 全集免费',
  slogan: '打开即看，下拉畅读，好看的韩国漫画尽在其中',
  description: '韩国漫画网汇集海量高清韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑、校园、古风等多元题材。每日同步更新最新话，支持下拉式全集观看模式，无需翻页等待。无论你是追更党还是补番族，都能在这里找到心仪的作品，享受丝滑流畅的在线阅读体验。',
  stats: [
    { label: '收录作品', value: '12,800+' },
    { label: '每日更新', value: '200+话' },
    { label: '高清画质', value: '1080P' },
  ],
};

export const mediaItems = [
  {
    title: '《霸道女王的反击》动画PV首发',
    desc: '年度最受期待韩漫改编动画，先导PV独家公开，感受复仇女王的华丽蜕变',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20confident%20queen%20character%20in%20elegant%20red%20dress%2C%20dramatic%20lighting%2C%20royal%20palace%20background%2C%20digital%20art%20aesthetic%2C%20vibrant%20colors%2C%20cinematic%20composition%2C%20soft%20glow%20effects%2C%20manga%20style%20rendering%20with%20clean%20lines&width=640&height=360&seq=media-01&orientation=landscape',
    tag: 'PV首发',
    views: '128万',
  },
  {
    title: '《剑域传说》第二季制作决定',
    desc: '异世界冒险再启程！第二季剧情全面升级，新角色新地图抢先预览',
    thumbnail: 'https://readdy.ai/api/search-image?query=fantasy%20webtoon%20art%20of%20a%20swordsman%20in%20ancient%20armor%20standing%20before%20a%20magical%20portal%2C%20ethereal%20glow%2C%20ancient%20ruins%2C%20dramatic%20clouds%2C%20Korean%20manhwa%20style%20digital%20painting%2C%20warm%20golden%20and%20teal%20color%20palette%2C%20epic%20scale&width=640&height=360&seq=media-02&orientation=landscape',
    tag: '新作情报',
    views: '96万',
  },
  {
    title: '韩漫推荐：五部宝藏冷门佳作',
    desc: '编辑精选五部被低估的冷门韩漫，画风细腻剧情炸裂，错过真的太可惜',
    thumbnail: 'https://readdy.ai/api/search-image?query=collection%20of%20beautiful%20webtoon%20style%20character%20portraits%20arranged%20in%20a%20gallery%20layout%2C%20various%20expressions%2C%20soft%20pastel%20colors%2C%20Korean%20illustration%20style%2C%20artistic%20composition%20with%20decorative%20elements%2C%20warm%20lighting&width=640&height=360&seq=media-03&orientation=landscape',
    tag: '编辑推荐',
    views: '73万',
  },
  {
    title: '《幽灵校舍》真人剧定档官宣',
    desc: '热门校园悬疑韩漫首次真人化！主演阵容曝光，原著粉狂喜期待值拉满',
    thumbnail: 'https://readdy.ai/api/search-image?query=dark%20atmospheric%20school%20hallway%20at%20night%20with%20mysterious%20silhouette%2C%20Korean%20thriller%20webtoon%20art%20style%2C%20blue%20moonlight%20through%20windows%2C%20suspenseful%20mood%2C%20digital%20illustration%20with%20sharp%20contrast%2C%20cinematic%20horror%20aesthetic&width=640&height=360&seq=media-04&orientation=landscape',
    tag: '影视改编',
    views: '156万',
  },
  {
    title: '作者访谈：《恋与制作人》幕后故事',
    desc: '独家对话人气漫画家，揭秘创作灵感、分镜技巧与角色设计的幕后花絮',
    thumbnail: 'https://readdy.ai/api/search-image?query=cozy%20artist%20studio%20with%20drawing%20tablet%20and%20sketches%20of%20romantic%20webtoon%20characters%20on%20wall%2C%20warm%20indoor%20lighting%2C%20creative%20workspace%2C%20Korean%20illustration%20studio%20vibe%2C%20soft%20colors%2C%20artistic%20atmosphere&width=640&height=360&seq=media-05&orientation=landscape',
    tag: '独家访谈',
    views: '42万',
  },
];

export const topics = [
  { name: '恋爱甜宠', icon: 'ri-heart-line', hot: true, count: '2,360部' },
  { name: '奇幻冒险', icon: 'ri-rocket-line', hot: true, count: '1,890部' },
  { name: '动作热血', icon: 'ri-fire-line', hot: true, count: '1,540部' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', hot: false, count: '980部' },
  { name: '校园青春', icon: 'ri-book-open-line', hot: false, count: '1,210部' },
  { name: '古风宫廷', icon: 'ri-ancient-gate-line', hot: false, count: '760部' },
  { name: '搞笑日常', icon: 'ri-emotion-laugh-line', hot: false, count: '1,030部' },
  { name: '惊悚恐怖', icon: 'ri-ghost-line', hot: false, count: '620部' },
  { name: 'BL/GL', icon: 'ri-heart-2-line', hot: false, count: '890部' },
];

export const appEntry = {
  title: '随时随地，畅读韩国漫画',
  desc: '下载韩国漫画APP，手机端专属阅读模式，离线缓存、夜间模式、智能推荐，让阅读从未如此便捷。',
  features: ['下拉式连续阅读', '高清画质无损缩放', '离线缓存随时看', '智能推荐发现好漫', '夜间模式护眼舒适'],
};

export const rankingItems = [
  { rank: 1, title: '霸道女王的反击', genre: '恋爱·职场', heat: '🔥 980万', change: 'up' },
  { rank: 2, title: '剑域传说', genre: '奇幻·冒险', heat: '🔥 875万', change: 'up' },
  { rank: 3, title: '幽灵校舍', genre: '悬疑·校园', heat: '🔥 762万', change: 'same' },
  { rank: 4, title: '恋与制作人', genre: '恋爱·都市', heat: '🔥 698万', change: 'up' },
  { rank: 5, title: '星际猎手', genre: '科幻·动作', heat: '🔥 634万', change: 'down' },
  { rank: 6, title: '魔女王座', genre: '奇幻·古风', heat: '🔥 589万', change: 'up' },
  { rank: 7, title: '我的契约男友', genre: '恋爱·奇幻', heat: '🔥 542万', change: 'same' },
];

export const indexItems = [
  {
    title: '恋爱甜宠精选',
    desc: '高甜恋爱韩漫合集，从校园初恋到霸道总裁，承包你的少女心',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20couple%20illustration%20in%20Korean%20webtoon%20style%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20warm%20tones%2C%20two%20characters%20holding%20hands%2C%20dreamy%20atmosphere%2C%20clean%20digital%20art%2C%20romantic%20manga%20aesthetic&width=400&height=280&seq=index-01&orientation=landscape',
    count: '236部',
  },
  {
    title: '奇幻异世界',
    desc: '转生穿越异世界，魔法与剑的史诗冒险，热血与感动交织的旅程',
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20world%20landscape%20with%20floating%20islands%20and%20magical%20glowing%20crystals%2C%20Korean%20manhwa%20art%20style%2C%20adventurer%20character%20silhouette%2C%20epic%20scale%2C%20warm%20golden%20light%2C%20digital%20painting%2C%20mystical%20atmosphere&width=400&height=280&seq=index-02&orientation=landscape',
    count: '189部',
  },
  {
    title: '悬疑烧脑剧场',
    desc: '反转不断的悬疑推理韩漫，每翻一页都是惊喜，烧脑爱好者必看',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20dimly%20lit%20library%20with%20detective%20elements%2C%20magnifying%20glass%20on%20old%20books%2C%20Korean%20thriller%20webtoon%20art%20style%2C%20atmospheric%20shadows%2C%20warm%20amber%20light%20from%20lamp%2C%20intriguing%20composition&width=400&height=280&seq=index-03&orientation=landscape',
    count: '98部',
  },
  {
    title: '古风宫廷传奇',
    desc: '华丽的古装韩漫世界，宫斗权谋与凄美爱情，穿越时空的浪漫之旅',
    cover: 'https://readdy.ai/api/search-image?query=traditional%20Korean%20palace%20courtyard%20with%20blooming%20plum%20blossoms%2C%20historical%20hanbok%20characters%20in%20elegant%20pose%2C%20soft%20watercolor%20style%2C%20muted%20warm%20tones%2C%20Korean%20historical%20painting%20aesthetic&width=400&height=280&seq=index-04&orientation=landscape',
    count: '76部',
  },
  {
    title: '动作热血竞技',
    desc: '拳拳到肉的热血格斗与竞技韩漫，燃到飞起的战斗场面不容错过',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20action%20scene%20with%20two%20fighters%20in%20intense%20combat%2C%20Korean%20manhwa%20style%2C%20motion%20lines%2C%20dramatic%20impact%20effects%2C%20urban%20rooftop%20setting%2C%20warm%20sunset%20lighting%2C%20energetic%20composition&width=400&height=280&seq=index-05&orientation=landscape',
    count: '154部',
  },
  {
    title: '校园青春物语',
    desc: '纯真美好的校园韩漫，友情、梦想与成长的故事，青春的每一个瞬间',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20campus%20scene%20with%20cherry%20blossoms%2C%20students%20in%20uniform%20walking%20and%20chatting%2C%20warm%20spring%20sunlight%2C%20webtoon%20art%20style%2C%20nostalgic%20atmosphere%2C%20clean%20digital%20illustration&width=400&height=280&seq=index-06&orientation=landscape',
    count: '121部',
  },
  {
    title: '搞笑日常治愈',
    desc: '治愈系搞笑韩漫合集，轻松诙谐的日常故事，疲惫生活中的快乐源泉',
    cover: 'https://readdy.ai/api/search-image?query=cute%20chibi%20style%20characters%20having%20fun%20in%20a%20cozy%20cafe%2C%20Korean%20comedy%20webtoon%20art%20style%2C%20warm%20and%20bright%20colors%2C%20playful%20expressions%2C%20comfortable%20atmosphere%2C%20humorous%20slice%20of%20life&width=400&height=280&seq=index-07&orientation=landscape',
    count: '103部',
  },
];

export const updateItems = [
  { time: '2分钟前', title: '《霸道女王的反击》第128话更新', type: '更新' },
  { time: '15分钟前', title: '《剑域传说》第95话已发布', type: '更新' },
  { time: '32分钟前', title: '《幽灵校舍》第73话上线', type: '更新' },
  { time: '1小时前', title: '新作《星辰坠落》第1话首发', type: '新作' },
  { time: '1小时前', title: '《恋与制作人》第56话更新', type: '更新' },
  { time: '2小时前', title: '《星际猎手》第102话发布', type: '更新' },
  { time: '3小时前', title: '《魔女王座》第88话热更中', type: '更新' },
  { time: '4小时前', title: '《我的契约男友》第61话上线', type: '更新' },
  { time: '5小时前', title: '周末特辑：十大完结佳作推荐', type: '专题' },
];

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20pink%20background%2C%20gentle%20smile%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20design%2C%20warm%20color%20palette&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '樱花落尽',
    date: '2天前',
    content: '追了三个月的《霸道女王的反击》终于等到高潮了！画风真的太绝了，每一格都能截图当壁纸。剧情节奏也把控得恰到好处，女主黑化那段看得我热血沸腾！强烈推荐给还没入坑的朋友～',
    likes: 1286,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=handsome%20anime%20style%20boy%20avatar%20portrait%2C%20cool%20expression%2C%20dark%20blue%20background%2C%20Korean%20manhwa%20style%2C%20clean%20simple%20design%2C%20modern%20look&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '追漫小王子',
    date: '3天前',
    content: '韩国漫画网是我用过最好用的漫画网站了，下拉式阅读真的爽，不用一页一页翻，体验感满分。而且更新速度超快，基本上韩国那边刚出，这里就有了。画质也是真的高清，细节看得很清楚。',
    likes: 958,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20glasses%2C%20warm%20brown%20background%2C%20shy%20smile%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜读书人',
    date: '5天前',
    content: '《幽灵校舍》的悬疑氛围营造得太好了！每一话结尾都留一个钩子，根本停不下来。而且网站的夜间模式超级贴心，晚上躲在被窝里看完全不刺眼。感谢韩国漫画网让我发现了这么多宝藏作品！',
    likes: 723,
  },
];

export const contactInfo = {
  title: '投稿与合作',
  desc: '如果你有原创漫画作品想要展示，或者有商务合作需求，欢迎通过以下方式联系我们。韩国漫画网期待与优秀的创作者和合作伙伴携手同行。',
  email: 'contact@koreancomics.cn',
  qq: '1234567890',
  wechat: 'koreancomics_official',
};

export const aboutInfo = {
  title: '关于韩国漫画网',
  desc1: '韩国漫画网成立于2019年，是国内领先的高清韩国漫画在线阅读平台。我们致力于为中国读者提供最新、最全、最高清的韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑、校园、古风等全品类题材。',
  desc2: '平台采用先进的下拉式阅读技术，支持连续翻页和无损高清画质，为读者打造沉浸式的移动端和桌面端阅读体验。我们与多家韩国漫画平台和独立创作者建立了合作关系，确保内容的丰富性与更新速度。',
  desc3: '截至2026年，平台已收录超过12,800部韩国漫画作品，累计服务超过500万读者，日均活跃用户超过80万。韩国漫画网始终坚持免费阅读的初心，让每一位漫画爱好者都能轻松享受优质内容。',
};

export const cardItems = [
  {
    title: '《霸道女王的反击》',
    desc: '职场女王一朝被害穿越重生，带着前世记忆开启复仇之路。商战、权谋与甜蜜爱情交织，看女王如何步步为营夺回属于自己的一切。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20businesswoman%20character%20in%20powerful%20pose%20with%20city%20skyline%20background%2C%20Korean%20webtoon%20art%20style%2C%20confident%20expression%2C%20luxurious%20office%20setting%2C%20dramatic%20lighting%2C%20red%20and%20gold%20accent%20colors%2C%20clean%20digital%20illustration&width=400&height=320&seq=card-01&orientation=landscape',
    tags: ['恋爱', '职场', '复仇'],
    rating: '9.6',
    status: '连载中',
  },
  {
    title: '《剑域传说》',
    desc: '平凡大学生意外穿越到剑与魔法的异世界，觉醒传说中的剑圣之力。在充满危险与奇遇的大陆上，少年踏上了寻找归途的史诗冒险。',
    cover: 'https://readdy.ai/api/search-image?query=young%20swordsman%20with%20glowing%20sword%20in%20fantasy%20landscape%2C%20Korean%20manhwa%20art%20style%2C%20magical%20auras%2C%20ancient%20ruins%20background%2C%20epic%20adventure%20vibe%2C%20dramatic%20clouds%2C%20warm%20golden%20light&width=400&height=320&seq=card-02&orientation=landscape',
    tags: ['奇幻', '冒险', '转生'],
    rating: '9.4',
    status: '连载中',
  },
  {
    title: '《幽灵校舍》',
    desc: '转学生搬进传说中的闹鬼宿舍，每晚都能听到诡异的声音。好奇心驱使下，她开始调查学校隐藏的秘密，却发现了比幽灵更可怕的真相。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20school%20building%20at%20night%20with%20mysterious%20light%20in%20one%20window%2C%20Korean%20horror%20webtoon%20style%2C%20eerie%20atmosphere%2C%20falling%20cherry%20blossom%20petals%2C%20moonlight%20shadows%2C%20suspenseful%20composition&width=400&height=320&seq=card-03&orientation=landscape',
    tags: ['悬疑', '校园', '惊悚'],
    rating: '9.5',
    status: '连载中',
  },
  {
    title: '《恋与制作人》',
    desc: '新手游戏制作人邂逅四位性格迥异的男神，在工作与感情的双重考验下，她能否在梦想与爱情之间找到平衡？甜到发齁的都市恋爱喜剧。',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20scene%20with%20a%20girl%20surrounded%20by%20four%20handsome%20male%20characters%2C%20Korean%20romance%20webtoon%20art%2C%20office%20setting%20with%20warm%20lighting%2C%20soft%20pastel%20colors%2C%20sparkling%20effects%2C%20dreamy%20atmosphere&width=400&height=320&seq=card-04&orientation=landscape',
    tags: ['恋爱', '都市', '甜宠'],
    rating: '9.3',
    status: '连载中',
  },
  {
    title: '《星际猎手》',
    desc: '未来星际时代，赏金猎人艾瑞克接下了一个看似简单的追捕任务，却意外卷入了一场席卷整个银河系的阴谋。机甲、星战与未知文明等你探索。',
    cover: 'https://readdy.ai/api/search-image?query=futuristic%20space%20bounty%20hunter%20character%20with%20high%20tech%20armor%2C%20Korean%20sci%20fi%20webtoon%20art%2C%20neon%20city%20background%2C%20starships%2C%20dramatic%20pose%2C%20vibrant%20holographic%20colors%2C%20dynamic%20composition&width=400&height=320&seq=card-05&orientation=landscape',
    tags: ['科幻', '动作', '机甲'],
    rating: '9.2',
    status: '连载中',
  },
  {
    title: '《魔女王座》',
    desc: '身为魔界最弱小的恶魔，她意外获得了魔王之力。为了守护珍视的人，她必须变强，在魔界权力斗争中杀出一条血路。暗黑奇幻史诗巨作。',
    cover: 'https://readdy.ai/api/search-image?query=demon%20queen%20character%20with%20dark%20wings%20and%20crown%2C%20gothic%20throne%20room%20background%2C%20Korean%20dark%20fantasy%20webtoon%20art%2C%20purple%20and%20black%20color%20scheme%2C%20mystical%20flames%2C%20powerful%20aura&width=400&height=320&seq=card-06&orientation=landscape',
    tags: ['奇幻', '古风', '暗黑'],
    rating: '9.4',
    status: '连载中',
  },
  {
    title: '《我的契约男友》',
    desc: '为了应付家里的催婚，她随便找了个人假装男友。谁知道这个契约男友竟然是隐藏身份的财阀继承人？假戏真做的甜蜜契约恋爱物语。',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20Korean%20webtoon%20scene%20of%20a%20couple%20in%20elegant%20clothing%20at%20a%20fancy%20restaurant%2C%20candlelight%20dinner%2C%20warm%20ambiance%2C%20soft%20smiles%2C%20luxurious%20setting%2C%20pink%20and%20gold%20tones&width=400&height=320&seq=card-07&orientation=landscape',
    tags: ['恋爱', '奇幻', '甜宠'],
    rating: '9.3',
    status: '连载中',
  },
];

export const featureItems = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式连续阅读',
    desc: '独创的下拉式阅读模式，告别传统翻页，像刷短视频一样流畅地阅读漫画。支持自动预加载，翻页零延迟。',
  },
  {
    icon: 'ri-hd-line',
    title: '1080P超高清画质',
    desc: '所有漫画均以1080P高清分辨率呈现，搭配智能图片压缩算法，保证画质的同时优化加载速度，细节分毫毕现。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日即时更新',
    desc: '与韩国各大漫画平台保持同步更新，热门作品韩国发布后最快30分钟内上线中文版，让你永远不会错过最新话。',
  },
];

export const faqItems = [
  {
    q: '韩国漫画网的漫画都是免费的吗？',
    a: '是的！韩国漫画网始终坚持免费阅读的原则，所有漫画作品均可免费在线阅读，无需付费或订阅。您只需要访问网站即可畅享全部内容。',
  },
  {
    q: '漫画的画质怎么样？支持手机阅读吗？',
    a: '所有漫画均提供1080P高清画质，同时针对移动端做了全面适配。无论是在电脑、平板还是手机上阅读，都能获得清晰流畅的体验。我们还提供夜间模式和字号调节功能。',
  },
  {
    q: '更新速度如何？能看到最新的韩国漫画吗？',
    a: '我们与韩国主流漫画平台保持密切合作，热门作品通常在韩国发布后30分钟至2小时内即可同步更新。每日更新量超过200话，保证您追更无忧。',
  },
  {
    q: '网站收录了多少部漫画？有哪些类型？',
    a: '目前平台已收录超过12,800部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、校园、古风、搞笑、惊悚、BL/GL等全品类题材。无论你喜欢什么类型，都能在这里找到心仪的作品。',
  },
  {
    q: '如何找到我想看的漫画？支持搜索吗？',
    a: '首页提供了热门排行、专题合集、分类标签等多种发现方式。您可以通过话题标签快速筛选感兴趣的题材，也可以通过排行榜发现当前最受欢迎的作品。',
  },
];

export const carouselItems = [
  {
    title: '2026夏季韩漫大赏',
    subtitle: '年度盛典',
    desc: '一年一度的夏季韩漫大赏正式开启！票选你心中的年度最佳漫画，参与即可获得专属阅读徽章。',
    cover: 'https://readdy.ai/api/search-image?query=grand%20award%20ceremony%20stage%20with%20golden%20spotlights%20and%20confetti%2C%20Korean%20webtoon%20award%20theme%2C%20elegant%20decorations%2C%20warm%20golden%20and%20red%20color%20palette%2C%20celebratory%20atmosphere%2C%20digital%20art%2C%20premium%20event%20aesthetic&width=800&height=420&seq=carousel-01&orientation=landscape',
    tag: '🔥 进行中',
  },
  {
    title: '新锐漫画家扶持计划',
    subtitle: '创作者招募',
    desc: '韩国漫画网启动新锐漫画家扶持计划，为有才华的原创漫画作者提供平台展示、流量推广与创作激励。',
    cover: 'https://readdy.ai/api/search-image?query=creative%20artist%20workspace%20with%20drawing%20tablet%20and%20colorful%20sketches%2C%20Korean%20webtoon%20creation%20theme%2C%20inspirational%20atmosphere%2C%20warm%20lighting%2C%20art%20supplies%2C%20modern%20studio%2C%20soft%20pastel%20background&width=800&height=420&seq=carousel-02&orientation=landscape',
    tag: '🎨 长期活动',
  },
  {
    title: '《剑域传说》第二季预热',
    subtitle: '重磅回归',
    desc: '超高人气奇幻巨作第二季确定于8月15日正式回归！全新剧情线、全新角色登场，敬请期待。',
    cover: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20warrior%20with%20sword%20facing%20massive%20dragon%20silhouette%2C%20Korean%20manhwa%20style%2C%20dramatic%20sunset%20sky%2C%20ancient%20temple%20ruins%2C%20cinematic%20lighting%2C%20golden%20and%20crimson%20tones&width=800&height=420&seq=carousel-03&orientation=landscape',
    tag: '📅 8月15日',
  },
  {
    title: '韩国漫画阅读报告2026',
    subtitle: '数据洞察',
    desc: '独家发布2026上半年韩国漫画阅读趋势报告，涵盖热门题材、读者画像与年度数据盘点。',
    cover: 'https://readdy.ai/api/search-image?query=data%20visualization%20dashboard%20with%20colorful%20charts%20and%20graphs%2C%20Korean%20webtoon%20analytics%20theme%2C%20modern%20infographic%20style%2C%20warm%20gradients%2C%20clean%20design%2C%20digital%20presentation%20aesthetic&width=800&height=420&seq=carousel-04&orientation=landscape',
    tag: '📊 数据分析',
  },
  {
    title: '七夕限定：甜蜜恋爱特辑',
    subtitle: '节日专题',
    desc: '七夕将至，我们精心挑选了50部高甜恋爱韩漫，陪你度过一个浪漫的七夕佳节。还有限定勋章等你领取。',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20starry%20night%20sky%20with%20milky%20way%2C%20Korean%20webtoon%20romance%20theme%2C%20two%20silhouettes%20on%20a%20bridge%2C%20lanterns%20floating%2C%20magical%20atmosphere%2C%20soft%20pink%20and%20purple%20hues%2C%20dreamy%20illustration&width=800&height=420&seq=carousel-05&orientation=landscape',
    tag: '💕 限时活动',
  },
];

export const footerData = {
  description: '韩国漫画网 — 国内领先的高清韩国漫画在线阅读平台。每日同步更新热门韩国漫画，支持下拉式全集观看，提供1080P超高清画质。涵盖恋爱、奇幻、动作、悬疑等多种题材，为漫画爱好者打造极致的在线阅读体验。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '精彩视频', href: '#media' },
        { label: '话题标签', href: '#topics' },
        { label: '热门排行', href: '#ranking' },
        { label: '专题合集', href: '#index' },
        { label: '更新动态', href: '#updates' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '常见问题', href: '#faq' },
      ],
    },
  ],
};